export const GET_TRAILERS_LIST = 'trailers/GET_TRAILERS_LIST';
export const getTrailersListAction = payload => ({
	type: GET_TRAILERS_LIST,
	payload,
});

export const SET_TRAILERS_LIST = 'trailers/SET_TRAILERS_LIST';
export const setTrailersListAction = payload => ({
	type: SET_TRAILERS_LIST,
	payload,
});

export const SET_PAGINATION = 'trailers/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const SET_IS_TRAILERS_LIST_LOADING = 'trailers/SET_IS_TRAILERS_LIST_LOADING';
export const setIsTrailersListLoadingAction = payload => ({
	type: SET_IS_TRAILERS_LIST_LOADING,
	payload,
});

export const SET_TABLE_SEARCH = 'trailers/SET_TABLE_SEARCH';
export const setTableSearchAction = payload => ({
	type: SET_TABLE_SEARCH,
	payload,
});

export const GET_TRAILER_TYPES = 'trailers/GET_TRAILER_TYPES';
export const getTrailerTypesAction = payload => ({
	type: GET_TRAILER_TYPES,
	payload,
});

export const GET_LIST_TRAILER_FILE_TYPES = 'trailers/GET_LIST_TRAILER_FILE_TYPES';
export const getListTrailerFileAction = payload => ({
	type: GET_LIST_TRAILER_FILE_TYPES,
	payload,
});

export const SET_TRAILER_TYPES = 'trailers/SET_TRAILER_TYPES';
export const setTrailerTypesAction = payload => ({
	type: SET_TRAILER_TYPES,
	payload,
});

export const SET_IS_TRAILER_TYPES_LOADING = 'trailers/SET_IS_TRAILER_TYPES_LOADING';
export const setIsTrailerTypesLoadingAction = payload => ({
	type: SET_IS_TRAILER_TYPES_LOADING,
	payload,
});

export const SET_IS_DOWNLOAD_LOADING = 'trailers/SET_IS_DOWNLOAD_LOADING';
export const setIsDownloadLoadingAction = payload => ({
	type: SET_IS_DOWNLOAD_LOADING,
	payload,
});

export const RESET_STATE = 'trailers/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});
